import { useSelector, useDispatch } from "react-redux";
export const useRedux = () => {
  const dispatch = useDispatch();
  const authState = useSelector((state: any) => state?.authReducer);
  const publicState = useSelector((state: any) => state?.publicReducer);
  const profileState = useSelector((state: any) => state?.profileReducer);
  const analysisState = useSelector((state: any) => state?.analysisReducer);
  const basketState = useSelector((state: any) => state?.basketReducer);
  const signalState = useSelector((state: any) => state?.signalReducer);
  const accountState = useSelector((state: any) => state?.accountReducer);
  const supportState = useSelector((state: any) => state?.supportReducer);
  const stockState = useSelector((state: any) => state?.stockReducer);
  const riskState = useSelector((state: any) => state?.riskReducer);
  const inquiryState = useSelector((state: any) => state?.inquiryReducer);
  const transformationState = useSelector((state: any) => state?.transformationReducer);
  const aiChatState = useSelector((state: any) => state?.aiChatReducer);
  const dashboardViewState = useSelector((state: any) => state?.dashboardViewReducer);

  return {

    dispatch,
    publicState,
    authState,
    profileState,
    analysisState,
    basketState,
    signalState,
    accountState,
    supportState,
    stockState,
    riskState,
    inquiryState,
    aiChatState,
    transformationState,
    dashboardViewState
  };
};
